<mat-card class="card" style="height: 300px;">
    <a href="http://katalog.hecht-kontaktlinsen.de/de/catalog/de/article/{{item.articleId}}" target="_blank">
        <div style="height: 200px;">
            <img [src]="item.imageUrl">
        </div>
        <mat-card-content style="margin-bottom: 0px;">
            <span style="width: 220px;">{{item.name}}</span>
        </mat-card-content>
    </a>
</mat-card>